import React, {useEffect, useState} from "react";
import {Divider, Stack, Typography} from "@mui/material";
import {dataManager} from "../../Broadtask";
import TaskableRuntimeCard from "./TaskableRuntimeCard";
import {sectionStack, subSectionPanel} from "../../../AppStyles";

const TaskableRuntimesPane = (props) => {

    const [runtimes, setRuntimes] = useState(null);

    useEffect(() => {
        dataManager.getTaskableManager().getInstance(props.taskableUID).getRuntimes(false, (profileRuntimes) => {
            setRuntimes(profileRuntimes);
        });
    }, [props.taskableUID]);

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%"
               alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/taskable_runtime_registration.png" width={32} height={32}/>
                    <Typography variant="h6">Runtimes</Typography>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="row" spacing={1} width="100%" minHeight={100}
                   sx={subSectionPanel}>
            {
                runtimes === null ?
                    <Typography>Loading...</Typography>:
                    runtimes.map(nextRuntime => {
                        return <TaskableRuntimeCard key={"runtime_" + nextRuntime.key} entry={nextRuntime} />
                    })
            }
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
);
}

export default TaskableRuntimesPane;
